var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectDetailsCostPerRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83341 1.66667V13.3333H15.1667V1.66667H1.83341ZM1.00008 0H16.0001C16.2211 0 16.4331 0.0877973 16.5893 0.244078C16.7456 0.400358 16.8334 0.61232 16.8334 0.833333V14.1667C16.8334 14.3877 16.7456 14.5996 16.5893 14.7559C16.4331 14.9122 16.2211 15 16.0001 15H1.00008C0.779068 15 0.567106 14.9122 0.410826 14.7559C0.254545 14.5996 0.166748 14.3877 0.166748 14.1667V0.833333C0.166748 0.61232 0.254545 0.400358 0.410826 0.244078C0.567106 0.0877973 0.779068 0 1.00008 0ZM8.50008 5V2.5L12.6667 6.66667H5.16675V5H8.50008ZM4.33341 8.33333H11.8334V10H8.50008V12.5L4.33341 8.33333Z",
    fill: "#A1B3C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDetailsCostPerRequest);
export default __webpack_public_path__ + "static/media/project-details-cost-per-request.d2403139659099b18475340d83279c0e.svg";
export { ForwardRef as ReactComponent };